const BASE = '[Counter]';

const CounterTypes = {
  increment: `${BASE} INCREMENT`,
  decrement: `${BASE} DECREMENT`,
  incrementByAmount: `${BASE} INCREMENT_BY_AMOUNT`,
};

export default CounterTypes;
